import React, { FC, useCallback, useContext, useEffect, useState } from 'react';

import { useActiveFilter } from 'component/Search/Filter/Active/__hooks/useActiveFilter';
import List from 'component/Search/Filter/Active/List';
import ToggleBar from 'component/Search/Filter/Active/ToggleBar';
import {
    EVENT_REMOVE_ALL_KI_FILTER,
    EVENT_REMOVE_KI_FILTER,
} from 'component/Search/Filter/AiSmartFilter/config';

import {
    SearchFormActionContext,
    SearchFormContext,
} from 'context/SearchFormContext';

import { filterReset } from 'data/Atom/Component';
import { filterStore } from 'data/Atom/Store';

import Portal from 'utility/Bind/Portal/Portal';
import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { SearchParam } from 'types/Search/params';

import { FilterAction } from 'proto/Search/ActiveFilter';

interface ListProps {
    target: string;
    mapTarget: string;
}

const MemoFilterList = React.memo(List);
const MemoFilterToggleBar = React.memo(ToggleBar);

export const ActiveFilterList: FC<ListProps> = ({ target, mapTarget }) => {
    const { activeFilterList } = useContext(SearchFormContext);
    const { removeActiveFilter, removeAllActiveFilter } = useContext(
        SearchFormActionContext
    );
    const { removeActiveFilterFromSearch, removeAllActiveFilterFromSearch } =
        useActiveFilter();

    const { react, components } = useContext(CommunicationContext);
    const [currentToggleBarKey, setCurrentToggleBarKey] = useState(0);

    const onFilterClick = useCallback(
        (filterActionList: FilterAction[], filterId: string) => {
            removeActiveFilter(filterId);
            removeActiveFilterFromSearch(filterActionList);
            react.dispatch(EVENT_REMOVE_KI_FILTER, filterId);
            if (filterActionList[0].parameter === SearchParam.GeoFence) {
                components.travel.map.mapService.disableDynamicSearch();
            }
        },
        [
            react,
            components.travel.map.mapService,
            removeActiveFilter,
            removeActiveFilterFromSearch,
        ]
    );

    const onResetAllClick = useCallback(() => {
        removeAllActiveFilter();
        removeAllActiveFilterFromSearch(activeFilterList);
        react.dispatch(EVENT_REMOVE_ALL_KI_FILTER);
        filterStore.set(filterReset, false);
        filterStore.set(filterReset, true);
        components.travel.map.mapService.disableDynamicSearch();
    }, [
        react,
        activeFilterList,
        components.travel.map.mapService,
        removeAllActiveFilter,
        removeAllActiveFilterFromSearch,
    ]);

    useEffect(() => {
        const onClose = () => {
            // increment key to force toggle state reset
            setCurrentToggleBarKey((key) => key + 1);
        };

        react.bind('map-close-active-filter-list', onClose);

        return () => {
            react.unbind('map-close-active-filter-list', onClose);
        };
    });

    return (
        <>
            <Portal root={target}>
                <MemoFilterList
                    activeFilterList={activeFilterList}
                    onFilterClick={onFilterClick}
                    onResetAllClick={onResetAllClick}
                />
            </Portal>
            {!!activeFilterList.length && (
                <Portal root={mapTarget}>
                    <MemoFilterToggleBar
                        key={currentToggleBarKey}
                        activeFilterList={activeFilterList}
                        onFilterClick={onFilterClick}
                        onResetAllClick={onResetAllClick}
                    />
                </Portal>
            )}
        </>
    );
};
